module.exports = __webpack_public_path__ + "img/asana.dca349a3.png";